module.exports = __webpack_public_path__ + "static/media/checkmark_active.294d1940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_active.svg
// module id = 64
// module chunks = 0